<template>
    <div class="favorite-brand-cls">
        <v-row>
            <div
                class="d-flex flex-row"
                v-for="item in items.data"
                :key="item.id"
            >
                <v-col cols="12" class="flex flex-column">
                    <v-row>
                        <v-col cols="4" class="flex flex-column pt-0 pb-0">
                            <div class="mb-4">
                                <span>{{
                                    $t(
                                        "backoffice.modules.estimate.product-families"
                                    )
                                }}</span>
                            </div>
                            <v-checkbox
                                v-model="item.allSelectedGenArts"
                                class="ml-3 checkbox-family"
                                :style="`min-width: 150px; max-width: 200px`"
                            >
                                <template v-slot:label>
                                    <v-tooltip
                                        bottom
                                        style="margin-bottom: 5px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <span
                                                style="cursor: pointer"
                                                class="p-0"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{
                                                    $t(
                                                        "backoffice.modules.estimate.all-families"
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <span>
                                            {{
                                                $t(
                                                    "backoffice.modules.estimate.checkbox-label"
                                                )
                                            }}
                                        </span>
                                    </v-tooltip>
                                </template>
                            </v-checkbox>
                        </v-col>
                        <v-col cols="7" class="flex flex-column pt-0 pb-0">
                            <div class="mb-4">
                                <span>{{
                                    $t(
                                        "backoffice.modules.estimate.favorite-brands"
                                    )
                                }}</span>
                            </div>
                            <v-checkbox
                                v-model="item.allSelectedBrands"
                                class="ml-3 checkbox-family2"
                                :style="`min-width: 150px; max-width: 200px`"
                            >
                                <template v-slot:label>
                                    <v-tooltip
                                        bottom
                                        style="margin-bottom: 5px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <span
                                                style="cursor: pointer"
                                                class="p-0"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{
                                                    $t(
                                                        "backoffice.modules.estimate.all-brands"
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <span>
                                            {{
                                                $t(
                                                    "backoffice.modules.estimate.checkbox-label"
                                                )
                                            }}
                                        </span>
                                    </v-tooltip>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" class="flex flex-column pt-0 pb-0">
                            <multiselect
                                :disabled="item.allSelectedGenArts"
                                v-model="item.selectedFavoriteFamilies"
                                label="text"
                                track-by="value"
                                :placeholder="$t('search')"
                                open-direction="bottom"
                                :options="item.allFamilies"
                                :multiple="true"
                                :searchable="true"
                                :loading="isLoading"
                                :internal-search="false"
                                :clear-on-select="true"
                                :close-on-select="false"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="
                                    (query) => asyncFind(query, true)
                                "
                            >
                                <template slot="afterList">
                                    <div
                                        v-if="allFamilies.hasMorePages"
                                        class="w-100 d-flex justify-content-center"
                                    >
                                        <v-btn
                                            text
                                            class="danger-button w-100 text-muted"
                                            @click="reachedEndOfListFamilies"
                                        >
                                            <span
                                                style="
                                                    text-transform: capitalize;
                                                "
                                                >{{
                                                    $t(
                                                        "backoffice.modules.estimate.load-more"
                                                    )
                                                }}</span
                                            >
                                        </v-btn>
                                    </div>
                                </template>
                                <template #tag="{ option, remove, label }">
                                    <span class="custom__tag">
                                        <span>{{ option.text }}</span>
                                        <span
                                            class="custom__remove"
                                            style="cursor: pointer"
                                            @click="remove(option)"
                                        >
                                            ❌
                                        </span>
                                    </span>
                                </template>
                                <template #clear="props">
                                    <div
                                        class="multiselect__clear"
                                        v-if="
                                            item.selectedFavoriteFamilies.length
                                        "
                                        @mousedown.prevent.stop="
                                            clearAll(props.search)
                                        "
                                    ></div>
                                </template>
                            </multiselect>
                        </v-col>
                        <v-col cols="7" class="flex flex-column pt-0 pb-0">
                            <multiselect
                                :disabled="item.allSelectedBrands"
                                v-model="item.selectedFavoriteBrands"
                                label="text"
                                track-by="value"
                                :placeholder="$t('search')"
                                open-direction="bottom"
                                :options="item.allBrands"
                                :multiple="true"
                                :searchable="true"
                                :loading="isLoading"
                                :internal-search="false"
                                :clear-on-select="true"
                                :close-on-select="false"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="
                                    (query) => asyncFind(query, false)
                                "
                            >
                                <template slot="afterList">
                                    <div
                                        v-if="allBrands.hasMorePages"
                                        class="w-100 d-flex justify-content-center"
                                    >
                                        <v-btn
                                            text
                                            class="danger-button w-100 text-muted"
                                            @click="reachedEndOfListBrands"
                                        >
                                            <span
                                                style="
                                                    text-transform: capitalize;
                                                "
                                                >{{
                                                    $t(
                                                        "backoffice.modules.estimate.load-more"
                                                    )
                                                }}</span
                                            >
                                        </v-btn>
                                    </div>
                                </template>
                                <template #tag="{ option, remove, label }">
                                    <span class="custom__tag">
                                        <span>{{ option.text }}</span>
                                        <span
                                            class="custom__remove"
                                            style="cursor: pointer"
                                            @click="remove(option)"
                                        >
                                            ❌
                                        </span>
                                    </span>
                                </template>
                                <template #clear="props">
                                    <div
                                        class="multiselect__clear"
                                        v-if="
                                            item.selectedFavoriteBrands.length
                                        "
                                        @mousedown.prevent.stop="
                                            clearAll(props.search)
                                        "
                                    ></div>
                                </template>
                            </multiselect>
                        </v-col>
                        <v-col
                            cols="1"
                            class="d-flex flex-column justify-content-center"
                        >
                            <div class="flex-row ml-md-2 ml-0">
                                <span
                                    @click="
                                        item.allSelectedBrands &&
                                        item.allSelectedGenArts
                                            ? undefined
                                            : onRemoveClicked(item.lineId)
                                    "
                                >
                                    <img
                                        :disabled="
                                            item.allSelectedBrands &&
                                            item.allSelectedGenArts
                                        "
                                        :src="
                                            item.allSelectedBrands &&
                                            item.allSelectedGenArts
                                                ? '/images/_SVGs/bo/remove-block.svg'
                                                : '/images/_SVGs/bo/remove.svg'
                                        "
                                        class="mt-4"
                                        style="cursor: pointer"
                                        width="25"
                                        height="25"
                                    />
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                    <hr class="mt-8" />
                </v-col>
            </div>

            <v-col cols="12">
                <div
                    :class="
                        $vuetify.breakpoint.xsOnly
                            ? 'text-center'
                            : 'text-start'
                    "
                >
                    <v-btn
                        :disabled="allSelected"
                        fab
                        x-small
                        :title="$t('backoffice.modules.estimate.add-brands')"
                        color="primary"
                        @click="handleClickNewFavoriteBrand"
                    >
                        <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {
    ModulesServicesBudgetSettingsFavoriteBrandsData,
    ModulesServicesBudgetSettingsFavoriteBrandsDropdown,
    ModulesServicesBudgetSettingsProductsFamiliesDropdown,
} from "@services/backoffice/Modules/ModulesServices";
import _ from "lodash";
import Multiselect from "vue-multiselect";

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    components: { Multiselect },
    data() {
        return {
            items: this.value,
            allFamilies: {
                data: [],
                backup: [],
                currentPage: 1,
                pageSize: 50,
                searchText: "",
            },
            allBrands: {
                data: [],
                backup: [],
                currentPage: 1,
                pageSize: 50,
                searchText: "",
            },
            searching: false,
            newIds: -1,
            isLoading: false,
        };
    },
    computed: {
        allSelected() {
            return this.items.data.some(
                (o) => o.allSelectedBrands && o.allSelectedGenArts
            );
        },
    },
    // watch: {
    //   value: {
    //     handler: function (newValue, oldValue) {
    //       console.log("n => ", newValue)
    //       return newValue;
    //     },
    //     deep: true,
    //     immediate: true
    //   }
    // },
    methods: {
        reachedEndOfListFamilies(reached) {
            if (reached && !this.searching) {
                this.isLoading = true;
                this.allFamilies.currentPage++;
                this.allFamilies.searchText = "";
                this.getFavoriteFamiliesDropdowns();
            }
            if (this.searching) {
                this.searching = false;
            }
        },
        reachedEndOfListBrands(reached) {
            if (reached && !this.searching) {
                this.isLoading = true;
                this.allBrands.currentPage++;
                this.allBrands.searchText = "";
                this.getFavoriteBrandsDropdowns();
            }
            if (this.searching) {
                this.searching = false;
            }
        },
        asyncFind(query, families) {
            this.isLoading = true;
            if (families) {
                this.allFamilies.currentPage = 1;
                this.allFamilies.searchText = query;
                this.getFavoriteFamiliesDropdowns(true);
            } else {
                this.allBrands.currentPage = 1;
                this.allBrands.searchText = query;
                this.getFavoriteBrandsDropdowns(true);
            }
        },
        onRemoveClicked(lineId) {
            this.items.data = this.items.data.filter((o) => o.lineId != lineId);
            this.handleChange();
        },
        handleClickNewFavoriteBrand() {
            this.items.data.push({
                lineId: --this.newIds,
                selectedFavoriteFamilies: [],
                selectedFavoriteBrands: [],
                allFamilies: _.cloneDeep(this.allFamilies.data),
                allBrands: _.cloneDeep(this.allBrands.data),
            });
            this.handleChange();
        },
        sortBy(a, b, field, index) {
            const aInPriority = this.items.data[index][field].includes(a.value);
            const bInPriority = this.items.data[index][field].includes(b.value);

            if (aInPriority && !bInPriority) {
                return -1;
            } else if (!aInPriority && bInPriority) {
                return 1;
            }
            return 0;
        },
        handleChange() {
            for (let i = 0; i < this.items.data.length; i++) {
                let families = _.cloneDeep(this.allFamilies.data);
                families.sort((a, b) =>
                    this.sortBy(a, b, "selectedFavoriteFamilies", i)
                );
                this.items.data[i].allFamilies = families;

                let brands = _.cloneDeep(this.allBrands.data);
                brands.sort((a, b) =>
                    this.sortBy(a, b, "selectedFavoriteBrands", i)
                );
                this.items.data[i].allBrands = brands;
            }

            this.$emit("input", this.items);
        },
        mergeArraysOfObjects(arr1, arr2) {
            let merged = arr1.concat(arr2);
            const uniqueValues = new Set();
            return merged.filter((obj) => {
                if (!uniqueValues.has(obj.value)) {
                    uniqueValues.add(obj.value);
                    return true;
                }
                return false;
            });
        },
        async getFavoriteFamiliesDropdowns(search = false) {
            await this.handleWithSearchParamFamilies(search);
            await this.$nextTick();

            await ModulesServicesBudgetSettingsProductsFamiliesDropdown(
                this.$route.params.userId,
                this.allFamilies
            )
                .then((response) => {
                    this.organizeFamiliesDrop(response.data, search);
                })
                .catch((error) => {
                    this.$emit("input", this.items);
                    this.isLoading = false;
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "error to get products families dropdown",
                        error
                    );
                });
        },
        async getFavoriteBrandsDropdowns(search = false) {
            await this.handleWithSearchParamBrands(search);

            return await ModulesServicesBudgetSettingsFavoriteBrandsDropdown(
                this.$route.params.userId,
                this.allBrands
            )
                .then((response) => {
                    this.organizeBrandsDrop(response.data, search);
                })
                .catch((error) => {
                    this.$emit("input", this.items);
                    this.isLoading = false;
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "error to get favorite brands dropdown",
                        error
                    );
                });
        },
        getFavoriteBrandsData() {
            this.items.data = [];
            this.$store.commit("loadings/setStateLoadingTemplate", true);

            ModulesServicesBudgetSettingsFavoriteBrandsData(
                this.$route.params.userId
            )
                .then((response) => {
                    // this.items.selectAll = response.data.result.some(
                    //     (o) => o.allSelected
                    // );

                    this.items.data = response.data.result;

                    // this.items.data = this.items.data.filter(
                    //     (o) => !o.allSelected
                    // );

                    this.items.data = this.items.data.map((line, index) => ({
                        lineId: line.lineID,
                        allBrands: [],
                        allFamilies: [],
                        allSelectedBrands: line.allSelectedBrands,
                        allSelectedGenArts: line.allSelectedGenArts,
                        selectedFavoriteFamilies: line.genArts.map((el) => ({
                            text: el.name,
                            value: +el.value,
                        })),
                        selectedFavoriteBrands: line.brands.map((el) => ({
                            text: el.name,
                            value: +el.value,
                        })),
                    }));
                })
                .catch((error) => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        "error to get favorite brands dropdown",
                        error
                    );
                })
                .finally(() => {
                    this.$emit("input", this.items);
                    this.getFavoriteFamiliesDropdowns();
                    this.getFavoriteBrandsDropdowns();
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        async organizeFamiliesDrop(data, search) {
            const arr2 = await Promise.all(
                data.result.map(async (el) => ({
                    text: el.name,
                    value: +el.value,
                }))
            );

            if (!search) {
                const mergeArrays = await this.mergeArraysOfObjects(
                    this.allFamilies.data,
                    arr2
                );
                this.allFamilies.data = _.cloneDeep(mergeArrays);
                if (
                    Array.isArray(this.items.data) &&
                    this.items.data.length > 0
                ) {
                    this.items.data.forEach((item) => {
                        item.allFamilies = _.cloneDeep(mergeArrays);
                    });
                }
            } else {
                this.allFamilies.data = _.cloneDeep(arr2);
                if (
                    Array.isArray(this.items.data) &&
                    this.items.data.length > 0
                ) {
                    this.items.data.forEach((item) => {
                        item.allFamilies = _.cloneDeep(arr2);
                    });
                }
            }

            this.allFamilies.hasMorePages = data.currentPage < data.totalPages;

            this.$emit("input", this.items);
            this.isLoading = false;

            await this.$nextTick();
        },
        async handleWithSearchParamFamilies(search) {
            if (search) {
                if (this.allFamilies.searchText) {
                    this.allFamilies.backup = _.cloneDeep(
                        this.allFamilies.data
                    );
                    this.allFamilies.data = [];
                } else {
                    this.allFamilies.data = _.cloneDeep(
                        this.allFamilies.backup
                    );
                }
                this.searching = true;
            }
        },
        async handleWithSearchParamBrands(search) {
            if (search) {
                if (this.allBrands.searchText) {
                    this.allBrands.backup = _.cloneDeep(this.allBrands.data);
                    this.allBrands.data = [];
                } else {
                    this.allBrands.data = _.cloneDeep(this.allBrands.backup);
                }
                this.searching = true;
            }
        },
        async organizeBrandsDrop(data, search) {
            const arr2 = await Promise.all(
                data.result.map(async (el) => ({
                    text: el.name,
                    value: +el.value,
                }))
            );

            if (!search) {
                const mergeArrays = await this.mergeArraysOfObjects(
                    this.allBrands.data,
                    arr2
                );
                this.allBrands.data = _.cloneDeep(mergeArrays);

                if (
                    Array.isArray(this.items.data) &&
                    this.items.data.length > 0
                ) {
                    this.items.data.forEach((item) => {
                        item.allBrands = _.cloneDeep(mergeArrays);
                    });
                }
            } else {
                this.allBrands.data = _.cloneDeep(arr2);
                if (
                    Array.isArray(this.items.data) &&
                    this.items.data.length > 0
                ) {
                    this.items.data.forEach((item) => {
                        item.allBrands = _.cloneDeep(arr2);
                    });
                }
            }

            this.allBrands.hasMorePages = data.currentPage < data.totalPages;

            this.$emit("input", this.items);
            this.isLoading = false;

            await this.$nextTick();
        },
    },
    mounted() {
        this.items = this.value;
        this.getFavoriteBrandsData();
    },
};
</script>

<style lang="scss">
.multiselect {
    min-height: 57px;
    border: 1px solid #949494;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 4px !important;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0;
}

.multiselect__tags {
    min-height: 57px !important;
    background: rgba(0, 0, 0, 0.06) !important;
}

.multiselect__input {
    background: rgba(0, 0, 0, 0.06) !important;
}

.multiselect__option--highlight {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option--highlight::after {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option:hover {
    color: #000 !important;
}

.multiselect__option--selected::after {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__content {
    padding-left: 0 !important;
}
</style>
